import React from "react";
import { formatDate } from "../../shared/helpers/formatters";
import "../../afs-walkthrough.css";

const fmtDate = formatDate;

// ─── Compilation Letter View (CSRS 4200 standard report) ─────────────────────
// Shows only the compilation engagement report letter, matching the CaseWare PDF
// format exactly. The text follows CSRS 4200 paragraphs with dynamic entity/date fields.

function CompilationLetterView({ compilationData, entityName, clientProfile, yearEnd }) {
	const yearEndLabel = yearEnd ? fmtDate(yearEnd) : "[Year End]";
	const entity       = (clientProfile && clientProfile.entityName) || entityName || "[Entity Name]";
	const firm         = compilationData.firm || "";
	const firmCity     = (clientProfile && clientProfile.city && clientProfile.province)
		? `${clientProfile.city}, ${clientProfile.province}` : "";
	const reportDate   = compilationData.noticeDate ? fmtDate(compilationData.noticeDate) : new Date().toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" });
	const comparatives = compilationData.comparatives !== false;

	// Build the standard CSRS 4200 compilation report paragraphs
	const priorYearLabel = yearEnd ? new Date(new Date(yearEnd).setFullYear(new Date(yearEnd).getFullYear() - 1)).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" }) : "";
	const statementsDesc = comparatives
		? `the balance sheet of ${entity} as at ${yearEndLabel} and ${priorYearLabel}, and the statements of retained earnings and income for the years then ended`
		: `the balance sheet of ${entity} as at ${yearEndLabel}, and the statements of retained earnings and income for the year then ended`;

	const paragraphs = [
		`On the basis of information provided by management, we have compiled ${statementsDesc}, and Note 1, which describes the basis of accounting applied in the preparation of the compiled financial information ("financial information").`,
		`Management is responsible for the accompanying financial information, including the accuracy and completeness of the underlying information used to compile it and the selection of the basis of accounting.`,
		`We performed this engagement in accordance with Canadian Standard on Related Services (CSRS) 4200, Compilation Engagements, which requires us to comply with relevant ethical requirements. Our responsibility is to assist management in the preparation of the financial information.`,
		`We did not perform an audit engagement or a review engagement, nor were we required to perform procedures to verify the accuracy or completeness of the information provided by management. Accordingly, we do not express an audit opinion or a review conclusion, or provide any form of assurance on the financial information.`,
		`Readers are cautioned that the financial information may not be appropriate for their purposes.`,
	];

	return (
		<div className="afs-letter">
			<h2 className="afs-letter__title">Compilation Engagement Report</h2>
			<p className="afs-letter__addressee">To the Management of {entity}</p>
			{paragraphs.map((p, i) => (
				<p key={i} className="afs-letter__paragraph">{p}</p>
			))}
			<div className="afs-letter__signature">
				{firmCity && <p className="afs-letter__sig-line">{firmCity}</p>}
				{firm && <p className="afs-letter__sig-bold">{firm}</p>}
				<p className="afs-letter__sig-line">{reportDate}</p>
				<p className="afs-letter__sig-designation">Chartered Professional Accountants</p>
			</div>
		</div>
	);
}

export default CompilationLetterView;
